<template>
    <v-container class="px-0" fluid v-show="innerShouldShow">
        <div v-if="!innerIsReview">
            <v-fade-transition mode="out-in">
                <validation-provider
                    v-slot="{ errors }"
                    mode="eager"
                    :rules="rules"
                    v-bind="providerProps"
                    v-show="innerShouldShow"
                    :vid="'validate-' + fieldAssignmentId"
                >
                    <h5 v-if="label" class="mb-2">{{ label }}</h5>
                    <span
                        class="field-directions"
                        v-if="directions"
                        v-html="directions"
                    ></span>
                    <v-container class="d-flex">
                        <v-btn
                            elevation="0"
                            x-large
                            height="60px"
                            @click="decrement"
                            :class="[
                                'rounded-0 rounded-l-lg number-incrementer--borders',
                                minError ? 'number-incrementer--error' : null
                            ]"
                            ><v-icon :color="minError ? 'red' : null"
                                >mdi-minus</v-icon
                            ></v-btn
                        >
                        <v-text-field
                            type="number"
                            outlined
                            v-model="innerValue"
                            v-bind="vProps"
                            min-height="50px"
                            :min="min"
                            :max="max"
                            :prefix="prefix"
                            :suffix="suffix"
                            :error="errors.length > 0"
                            @focus="clearErrors"
                            class="mt-0 pt-0 rounded-0 number-incrementer__text-field text-center"
                            style="max-width: 150px; border-right: 0px; border-left: 0px;"
                        />
                        <!-- <v-text-field
                v-model="innerValue"
                field-type="text-box"
                v-bind="vProps"
                :error-messages="errors"
                outlined
                class="mt-0 pt-0 rounded-0"
                style="max-width: 65px; max-height: 40px"
              ></v-text-field> -->
                        <!--                         :disabled="parseInt(max) === innerValue"  -->
                        <v-btn
                            elevation="0"
                            x-large
                            height="60px"
                            @click="increment"
                            :class="[
                                'rounded-0 rounded-r-lg number-incrementer--borders',
                                maxError ? 'number-incrementer--error' : null
                            ]"
                            ><v-icon :color="maxError ? 'red' : null"
                                >mdi-plus</v-icon
                            ></v-btn
                        >
                    </v-container>
                </validation-provider>
                <div v-if="minError || maxError" class="mt-n8">
                    <small class="red--text">{{ errorMessage }}</small>
                </div>
            </v-fade-transition>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                <div v-if="innerValue">
                    {{ prefix }}{{ innerValue }}{{ suffix }}
                </div>
                <div v-else>N/A</div>
            </type-review>
        </div>
    </v-container>
</template>

<script>
import formMixin from '../formMixin';
import TypeReview from './TypeReview';
import * as _ from "lodash";
// TODO: more validation

export default {
    name: 'TypeNumberIncrementer',
    mixins: [formMixin],
    components: {
        TypeReview
    },
    props: {
        min: {
            type: Number | String,
            default: null // TODO: set this to null when the admin is working
        },
        max: {
            type: Number | String,
            default: null // TODO: set this to null when the admin is working
        },
        step: {
            type: Number | String,
            default: null
        },
        prefix: {
            type: String,
            default: null
        },
        suffix: {
            type: String,
            default: null // TODO: set this to null when the admin is working
        }
    },
    data() {
        return {
            minError: false,
            maxError: false,
            errorMessage: null
        };
    },
    mounted() {
        this.init();
        this.fieldLoaded(); // signal to the form we are loaded
    },
    computed: {
        defaults() {
            return {
                directions: this.directions,
                persistentHint: true
            };
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings,
                // ...(this.componentProps.required && { required: true }),
                ...this.validation,
                ...{
                    required:
                        !!this.validation_settings.required &&
                        !!this.innerShouldShow
                }
            } : {};
        }
    },
    watch: {
        innerShouldShow(n, o) {
            if (n) this.init();
        }
    },
    methods: {
        init() {
            if (!this.innerValue) {
                if( this.min ) {
                    setTimeout(() => {
                        // give the rest of the form time to load in case of dependencies
                        this.innerValue = this.min;
                    }, 250);
                }
            } else {
                if( this.innerValue ) { // signal form logic for default values
                    this.innerValue = _.cloneDeep(this.innerValue);
                }
            }
        },
        setDecimalPlaces(val, num) {
            if (parseFloat(val) % 1 != 0)
                this.innerValue = parseFloat(val).toFixed(num);
        },
        increment() {
            this.minError = false;
            if (this.max && this.innerValue >= parseFloat(this.max)) {
                this.maxError = true;
                this.errorMessage = `Maximum of ${
                    this.prefix ? this.prefix : ''
                }${this.max}${this.suffix ? this.suffix : ''} accepted.`;
            } else {
                this.maxError = false;
                this.errorMessage = null;

                if (parseFloat(this.innerValue) % parseFloat(this.step) !== 0)
                    this.innerValue =
                        this.innerValue -
                        (parseFloat(this.innerValue) % parseFloat(this.step));

                this.innerValue =
                    parseFloat(this.innerValue) + parseFloat(this.step);
            }

            // check for decimal places
            this.setDecimalPlaces(this.innerValue, 2);
        },
        decrement() {
            this.maxError = false;
            if (this.min && this.innerValue <= parseFloat(this.min)) {
                this.minError = true;
                this.errorMessage = `Minimum of ${
                    this.prefix ? this.prefix : ''
                }${this.min}${this.suffix ? this.suffix : ''} accepted.`;
            } else {
                this.minError = false;
                this.errorMessage = null;

                if (parseFloat(this.innerValue) % parseFloat(this.step) !== 0)
                    this.innerValue =
                        this.innerValue -
                        (parseFloat(this.innerValue) % parseFloat(this.step));

                this.innerValue =
                    parseFloat(this.innerValue) - parseFloat(this.step);
            }

            // check for decimal places
            this.setDecimalPlaces(this.innerValue, 2);
        },
        clearErrors() {
            this.maxError = false;
            this.minError = false;
            this.errorMessage = null;
        }
    }
};
</script>

<style lang="scss" scoped>
.number-incrementer {
    &--borders {
        border: 1px solid #0000001f;
    }
    &--error {
        border: 1px solid #f44336;
        background-color: #ffcdd2 !important;
    }
}
</style>

<style lang="scss">
.number-incrementer__text-field {
    input {
        text-align: center;
    }
    .v-input__slot {
        height: 60px;
    }
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type='number'] {
    -moz-appearance: textfield;
}
</style>
